module.exports = __webpack_public_path__ + "img/local_gas_station.53d5e582.svg";